export const formatCurrency = (value: number): string => {
  return Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};

export const unformatCurrency = (value: string): number =>
  value ? Number(value.replace(/\D/g, '')) / 100 : 0;
